import React, { PureComponent } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'

import StudentInfo from '../../../components/StudentInfo'
import Exception from '../../../components/Exception'

import moment from 'moment'
import { Button, Card, Col, Form, Icon, notification, Row, Select, Tooltip } from 'antd'
import _ from 'lodash'
import StudentHeader from '../../../components/studentHeader'
import common from '../../common.less'
import { hideLoader, showLoader } from '../../../modules/actions'

import Request, { API_URL, MEDIA_URL } from '../../../request'
import { connect } from 'react-redux'
import { getUrlPushWrapper } from '../../../routes'


const Option = Select.Option

@Form.create()
class Enrollment extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            inquiryId: null,
            info: null,
            visible: false,
            mailer: false,
            course: [],
            moveToNextDesk: false,
            choosenCourseId: null,
            files: [],
            smsCounselor: null,
            emailStudent: null,
            smsStudent: null,
            allow: true

        }

        this.mailer = React.createRef()


    }

    componentDidMount() {
        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')
        if (inquiryId) {
            this.setState({ inquiryId: inquiryId })
            this.setFormValues(inquiryId)
        }
    }


    calback = val => {
        let cloneCourse = _.clone(this.state.course)
        let findCourse = _.find(cloneCourse, item => {
            return item.courseId == val.courseId
        })
        if (findCourse) {
            notification.success({
                message: 'Success',
                description: 'Course already exists.'
            })
        } else {


            cloneCourse.push(val)

            this.setState({
                course: cloneCourse
            })
        }
    }

    MailerCallback = () => {


    }


    closeFollowUp = () => {
        this.setState({ visible: false })
    }

    closeMailer = () => {
        this.setFormValues(this.state.inquiryId)
        this.setState({ mailer: false })
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            if (this.state.courseUniversityId) {
                params.courseUniversityId = this.state.courseUniversityId
                params.page = 1
            }
            if (params.sortField && params.sortField == 'courseName') {
                params.sortField = 'course.courseName'
            }
            let data = await Request.getAllCourse({
                ...params,
                regExFilters: ['courseName']
            })
            this.setState({ total: data.total })
            resolve(data)
        })
    }

    removeCourse = item => {
        let cloneCourse = _.clone(this.state.course)
        cloneCourse = _.reject(cloneCourse, itemV => {
            return item._id == itemV._id
        })
        this.setState({
            course: cloneCourse
        })
    }

    showDrawer = () => {
        this.setState({
            visible: true
        })
    }

    showMailer = (item) => {

        this.setState({ choosenCourseId: item.courseId }, () => {
            this.setState({ mailer: true })
        })
    }


    setFormValues = async inquiryId => {
        const { dispatch, form } = this.props
        try {
            let { doc, allow } = await Request.getInquiry(inquiryId)
            if (doc && allow) {

                let docLoaded = doc.applicationsDesk
                let inputTypes = this.state
                _.each(docLoaded, (item, key) => {
                    inputTypes[key] = item
                })
                this.setState({
                    ...inputTypes
                })


                let findIn = _.find(doc.applicationsDesk.course, (val) => {

                    return (val && val.stage2 && val.stage2.offerStatus == 'Offer Done' && doc.atLevel == 'Application Desk')

                })


                let { course: applicationCourse = [] } = doc.applicationsDesk


                this.setState({ info: doc, moveToNextDesk: findIn ? true : false }, () => {

                })
            } else {
                this.setState({ allow: false })
            }
        } catch (e) {
            console.log(e)
        }
    }

    saveApplicationIntake = async (item) => {
        if (!item.choosenIntake) {
            return notification.error({
                message: 'Choose Intake'
            })
        }

        const { dispatch } = this.props


        let obj = {
            _id: this.state.info._id,
            course: {

                courseId: item.courseId,
                courseName: item.courseName,
                tutionFee: item.tutionFee ? parseInt(item.tutionFee) : 0,
                pathwayId: item.pathwayId,
                pathwayName: item.pathwayName,
                intake: item.choosenIntake,
                universityId: item.universityId,
                universityInstitutionName: item.universityInstitutionName,
                applicationDate: new Date()
            }
        }

        dispatch(showLoader())
        let x = await Request.addApplicationIntake(obj)
        dispatch(hideLoader())
        if (x.success) {
            this.setFormValues(this.state.inquiryId)
            return notification.success({
                message: x.msg

            })


        } else {
            return notification.error({
                message: x.msg

            })
        }

        dispatch(hideLoader())

    }
    saveApplicationStatus = async (item) => {
        if (!item.stage1.status) {
            return notification.error({
                message: 'Choose Status'
            })
        }

        const { dispatch } = this.props

        let obj = {
            _id: this.state.inquiryId,
            courseId: item.courseId,
            stage1: item.stage1
        }

        dispatch(showLoader())
        let x = await Request.saveApplicationStatus(obj)
        dispatch(hideLoader())

        if (x.success) {
            this.setFormValues(this.state.inquiryId)
            return notification.success({
                message: x.msg

            })

        } else {
            return notification.error({
                message: x.msg

            })
        }

        dispatch(hideLoader())

    }

    handleChange = v => {
        if (v.fileList) {
            this.setState({ files: v.fileList })
        }
    }

    onRemove = v => {
        console.log(v)
    }

    uploadOffer = (courseId) => {
        let obj = {
            _id: this.state.inquiryId,
            courseId: courseId,
            files: this.state.files


        }

        if (!this.state.files || !this.state.files.length) {
            return notification.error({ message: 'Choose a file' })
        }

        const { dispatch } = this.props

        dispatch(showLoader())
        Request.uploadOffer(obj)
            .then(resp => {
                dispatch(hideLoader())
                if (resp.success) {
                    this.setFormValues(this.state.inquiryId)

                    return notification.success({
                        message: 'Success',
                        description: resp.msg
                    })
                }
                if (resp.error) {
                    return notification.error({ message: 'Error', description: resp.msg })
                }
            })
            .catch(err => {
                dispatch(hideLoader())
                console.log(err)
            })
    }

    removeAppCourse = async (courseId) => {

        const { dispatch } = this.props


        let obj = {
            _id: this.state.inquiryId,
            courseId
        }


        dispatch(showLoader())
        let response = await Request.removeApplicationCourse(obj)
        dispatch(hideLoader())
        if (response && response.success) {
            notification.success({
                message: 'Success',
                description: response.msg
            })
            this.setFormValues(this.state.inquiryId)
        } else {
            notification.error({
                message: 'Error',
                description: 'Try again'
            })
        }

    }

    finalStep = async (obj) => {


        const { dispatch } = this.props

        obj._id = this.state.inquiryId


        if (!obj.smsCounselor && !obj.smsStudent && !obj.emailStudent) {
            return notification.warning({
                message: 'Required',
                description: 'Choose at least one option.'
            })
        }

        dispatch(showLoader())
        let response = await Request.studentApplicationDone(obj)
        dispatch(hideLoader())
        if (response && response.success) {
            notification.success({
                message: 'Success',
                description: response.msg
            })
            this.setFormValues(this.state.inquiryId)
        } else {
            notification.error({
                message: 'Error',
                description: 'Try again'
            })
        }


    }


    render() {
        const { submitting, dispatch } = this.props
        const { info, course, choosenCourseId, inquiryId, moveToNextDesk, allow } = this.state


        const courseColumns = [
            {
                title: 'Course Name',
                dataIndex: 'courseName',
                key: 'courseName'
            },
            {
                title: 'University',
                dataIndex: 'universityInstitutionName',
                key: 'universityInstitutionName'
            },
            {
                title: 'PathWay',
                dataIndex: 'pathwayName',
                key: 'pathwayName'
            },
            {
                title: 'Fees/Duration',
                width: 150,
                key: 'tutionFee',
                dataIndex: 'tutionFee',
                render: (val, record) => {
                    return (
                        <div>
                            <span>{record.tutionFee}</span>
                            <span>{record.courseDuration}</span>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                fixed: 'right',
                width: 150,
                render: (item, record) => (
                    <React.Fragment>
                        <Tooltip title="Remove Course">
                            <Button
                                type="danger"
                                shape="circle"
                                onClick={() => {
                                    this.removeCourse(item)
                                }}
                                icon="delete"
                            />
                        </Tooltip>
                    </React.Fragment>
                )
            }
        ]


        return (
            allow ? <PageHeaderWrapper
                title={info && info.studentName ? `Enrollment of ${info.studentName}` : 'Application Screen'}>


                {
                    info && info._id ? <div>
                        <div style={{ marginBottom: 10 }}>
                            <StudentHeader
                                rollBackLevel={'Registration Desk'}
                                done={() => {
                                    dispatch(getUrlPushWrapper('desk.application'))
                                }}
                                info={this.state.inquiryId}
                                data={info}
                                dispatch={this.props.dispatch}
                            />
                        </div>
                    </div>
                        : null}

                {
                    info ? <Card bordered={true} style={{ marginBottom: 10 }}>
                        <StudentInfo
                            info={info}
                        />
                    </Card> : null
                }


                <Card bordered={true} loading={!info}>
                    {
                        info && info.atLevel == 'Application Desk' ? <Button
                            type="default"
                            onClick={() => this.showDrawer()}
                            style={{ marginBottom: 10 }}>
                            Click here to choose a course
                        </Button>
                            : null
                    }


                    <div style={{ background: '#ECECEC', padding: '10px' }}>
                        <Row>
                            {


                                course && course.map((item, index) => {


                                    const { stage1, stage2, stage3 } = item

                                    let offerurl = `${MEDIA_URL}${stage3 && stage3.offerUpload && stage3.offerUpload.url ? stage3.offerUpload.url : null}`


                                    return (
                                        <Col key={index}>
                                            <div className={common.custCard}>
                                                <div className={common.section}>
                                                    <div><b>{item.courseName}</b> ({item.universityInstitutionName})</div>
                                                    <div>Fee: {item.tutionFee} </div>
                                                    {item.pathwayName ? <div>Pathway: {item.pathwayName} </div> : null}


                                                </div>
                                                <div className={common.section}>


                                                    <Row>
                                                        <Col span={6} className={common.success}><b> Intake
                                                            : </b>{moment(item.intake).format('DD-MMM-YYYY')} </Col>
                                                        <Col span={6} className={common.success}>
                                                            Application Processed
                                                            <div>
                                                                <small>{moment(stage2.mailStatusDate).format('DD-MMM-YYYY')} </small>
                                                            </div>
                                                        </Col>
                                                        <Col span={6}>
                                                            <a
                                                                href={`${offerurl}`}
                                                                style={{
                                                                    color: 'blue',
                                                                    textDecorationLine: 'underline'
                                                                }}
                                                                target={'_blank'}>
                                                                Download Offer <Icon type="download" />
                                                            </a>
                                                        </Col>
                                                    </Row>


                                                </div>


                                            </div>

                                        </Col>
                                    )
                                })

                            }
                        </Row>

                        {
                            !course.length ? 'No enrollment' : null
                        }


                    </div>


                </Card>


            </PageHeaderWrapper> : <Exception />


        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Enrollment)
